
import React, { useEffect, useState } from 'react'
import { Card, List, Button, Input, Space, Modal, message } from 'antd'
import { PlusOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons'
import {
  getExpenseCategories,
  createExpenseCategory,
  updateExpenseCategory,
  deleteExpenseCategory,
} from "../../api/expenseCategoryApi";


import { notify } from '../components/Customs/NotifyProvider'
import { Empty } from 'antd'
import { canViewModule, canCreateModule, canUpdateModule, canDeleteModule } from '../utils/permissionUtils'

const ManageExpesecat = () => {
    const MODULE_KEY = 'manage_expense'
    const canView = canViewModule(MODULE_KEY)
    const canCreate = canCreateModule(MODULE_KEY)
    const canUpdate = canUpdateModule(MODULE_KEY)
    const canDelete = canDeleteModule(MODULE_KEY)
    const [amenities, setAmenities] = useState([])
    const [newAmenity, setNewAmenity] = useState('')
    const [search, setSearch] = useState('')
    const [editing, setEditing] = useState(null)
    const [editingValue, setEditingValue] = useState('')
    const [isModalOpen, setIsModalOpen] = useState(false)

    const loadAmenities = async () => {
  if (!canView) return
  try {
    const res = await getExpenseCategories();
    setAmenities(res.data.data || []);
  } catch (error) {
    console.error(error);
    notify.error("Failed to load categories");
  }
};

    useEffect(() => {
        loadAmenities()
    }, [])

    const persist = (next) => {
        setAmenities(next)
    }

   const handleAdd = async () => {
      if (!canCreate) {
        notify.error("Permission Denied", "No permission to create expense category")
        return
      }
      const value = newAmenity.trim();

      if (!value) {
        notify.warning("Enter category name");
        return;
      }

      if (amenities.some(a => a.name === value)) {
        notify.warning("Category already exists");
        return;
      }

      const payload = {
        name: value,
      };

      try {
        const res = await createExpenseCategory(payload);

        if (res.data.status) {
          loadAmenities();
          setNewAmenity("");
          notify.success("Category added");
        }
      } catch (err) {
        console.error(err);
        notify.error("Failed to add category");
      }
    };

    const openEdit = (item) => {
        setEditing(item.id)
        setEditingValue(item.name)
        setIsModalOpen(true)
    }

    const handleEditSave = async () => {
      if (!canUpdate) {
        notify.error("Permission Denied", "No permission to update expense category")
        return
      }
      const value = editingValue.trim();

      if (!value) {
        notify.warning("Category cannot be empty");
        return;
      }

      try {
        const res = await updateExpenseCategory(editing, {
          name: value
        });

        if (res.data.status) {
          loadAmenities();
          setIsModalOpen(false);
          setEditing(null);
          notify.success("Updated successfully");
        }
      } catch (err) {
        console.error(err);
        notify.error("Update failed");
      }
    };

    const handleDelete = async (item) => {
  if (!canDelete) {
    notify.error("Permission Denied", "No permission to delete expense category")
    return
  }
  try {
    const res = await deleteExpenseCategory(item.id);

    if (res.data.status) {
      loadAmenities();
      notify.success("Deleted successfully");
    }
  } catch (err) {
    console.error(err);
    notify.error("Delete failed");
  }
};

    if (!canView) {
      return (
        <Card>
          <Empty description="No permission to view expense categories" />
        </Card>
      )
    }

    return (
        <Card title={
            <div>
              <div style={{ fontWeight: 600, fontSize: 20 }}>
                Expense Categories
              </div>
              <div style={{ fontSize: 12, color: "#888" }}>
                Manage and organize your expense categories
              </div>
            </div>
          }
            extra={
                <Input
                    size='large'
                    placeholder="Search Expenses Category"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    style={{ width: 320 }}
                    allowClear
                />
            }
        >


            <Space style={{ marginBottom: 16, width: '100%', justifyContent: 'space-between' }}>
                <Input
                    size='large'
                    allowClear
                    placeholder="Add Expenses Category (e.g., Electricitiy)"
                    value={newAmenity}
                    onChange={(e) => setNewAmenity(e.target.value)}
                    onPressEnter={() => canCreate && handleAdd()}
                    style={{ width: 420 }}
                    disabled={!canCreate}
                />
                <Button size='large' type="primary" icon={<PlusOutlined />} onClick={handleAdd} disabled={!canCreate}>
                    Add
                </Button>
            </Space>

            <List
                bordered
                dataSource={amenities.filter((item) =>
                    item.name.toLowerCase().includes(search.trim().toLowerCase())
                )}
                locale={{ emptyText: 'No Expenses Category found!' }}
                renderItem={(item) => (
                    <List.Item
                        actions={[
                            <Button
                                key="edit"
                                type="text"
                                icon={<EditOutlined />}
                                disabled={!canUpdate}
                                onClick={() => openEdit(item)}
                            />,
                            <Button
                                key="delete"
                                type="text"
                                danger
                                icon={<DeleteOutlined />}
                                disabled={!canDelete}
                                onClick={() => handleDelete(item)}
                            />,
                        ]}
                    >
                        {item.name}
                    </List.Item>
                )}
            />

            <Modal
                title="Edit Expenses Category"
                open={isModalOpen}
                onOk={handleEditSave}
                onCancel={() => setIsModalOpen(false)}
                okText="Save"
            >
                <Input
                    value={editingValue}
                    onChange={(e) => setEditingValue(e.target.value)}
                    onPressEnter={handleEditSave}
                />
            </Modal>
        </Card>
    )
}

export default ManageExpesecat
